import { GoogleTagManagerForm, GoogleTagManagerParams, MatomoAnalyticsForm } from 'types/other';

import { api } from './setupApi';

class AnalyticsProviderModel {
  link = '/analytics_providers';

  gtmLink = `${this.link}/gtm`;

  matomoLink = `${this.link}/matomo`;

  getGoogleTagManagerSettings = (): Promise<GoogleTagManagerForm> =>
    api.get(this.gtmLink).then(({ data }) => data.analyticsProvider);

  updateGoogleTagManagerSettings = (data: GoogleTagManagerParams) =>
    api.put<GoogleTagManagerParams>(this.gtmLink, data).then(({ data }) => data);

  getMatomoSettings = (): Promise<MatomoAnalyticsForm> =>
    api.get(this.matomoLink).then(({ data }) => data.analyticsProvider);

  updateMatomoSettings = (data: GoogleTagManagerParams): Promise<Partial<MatomoAnalyticsForm>> =>
    api.put(this.matomoLink, data).then(({ data }) => data.analyticsProvider);
}

export const analyticsProviderModel = new AnalyticsProviderModel();
